<template>
	<div class="layer" :class="layerClass" @click.stop="closeLayer">
		<slot></slot>
	</div>
</template>

<script>
import {getComponentId, eventBus} from './event-bus.mjs';

export default {
	props: {
		name: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			componentId: getComponentId(),
			open: false,
			top: 0,
			left: 0
		};
	},
	computed: {
		layerClass() {
			return {
				open_layer: this.open
			};
		}
	},
	methods: {
		openLayer({layerName}) {
			if (layerName !== this.name) {
				return;
			}

			eventBus.$emit('close-layer', this.componentId);
			this.open = true;
		},
		closeLayer(senderComponentId = '') {
			if (senderComponentId === this.componentId) {
				return;
			}

			this.open = false;
		}
	},
	created() {
		eventBus.$on('open-layer', this.openLayer);
		eventBus.$on('close-layer', this.closeLayer);
	},
	beforeDestroy() {
		eventBus.$off('open-layer');
		eventBus.$off('close-layer');
	}
}
</script>
